import React from "react";
import { ModalBody as RSModalBody } from "reactstrap";

const ModalBody = ({ children }) => {
  return <RSModalBody>{children}</RSModalBody>;
};

export default ModalBody;
